var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"words",class:{ skelly: !_vm.init, collapsed: _vm.collapsed }},[_c('ul',{staticClass:"list"},_vm._l((_vm.words),function(word){return _c('li',{key:word.word,staticClass:"word",class:{ pangram: word.pangram }},[_vm._v(" "+_vm._s(word.word)),(!_vm.collapsed)?[_vm._v(" ("+_vm._s(word.score)+")")]:_vm._e()],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }